import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import * as Data from "@/data";
export default
/*#__PURE__*/
(function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Vue = _ref.Vue;
            Vue.directive("permission", {
              inserted: function inserted(el, binding, vnode) {
                var permission = binding.modifiers;
                var read = permission.Read;
                var write = permission.Write;
                var hasPermission = false;
                var propertyId = binding.value;
                if (Data.Authentication.IsMHDCUser(true)) return;

                for (var i in permission) {
                  if (i != "Read" && i != "Write") {
                    if (propertyId) {
                      if (write == true) {
                        hasPermission = Data.Authentication.HasWritePropertyPermission(i, propertyId);
                      } else if (read == true) {
                        hasPermission = Data.Authentication.HasReadPropertyPermission(i, propertyId);
                      }
                    } else if (write == true) {
                      hasPermission = Data.Authentication.HasWritePermission(i);
                    } else if (read == true) {
                      hasPermission = Data.Authentication.HasReadPermission(i);
                    }
                  }
                }

                if (!hasPermission && vnode.elm && vnode.elm.parentElement) vnode.elm.parentElement.removeChild(vnode.elm);
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();